import { render, staticRenderFns } from "./Error-1.vue?vue&type=template&id=0d5781e9&"
import script from "./Error-1.vue?vue&type=script&lang=js&"
export * from "./Error-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5781e9')) {
      api.createRecord('0d5781e9', component.options)
    } else {
      api.reload('0d5781e9', component.options)
    }
    module.hot.accept("./Error-1.vue?vue&type=template&id=0d5781e9&", function () {
      api.rerender('0d5781e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/error/Error-1.vue"
export default component.exports